import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {images} from '../../../../assets/icons';
import {ViewProps} from './model';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../shared/routing';
import {useTheme} from '../../../../shared/theme';
import {DeviceSize} from '../../../../shared/theme/helpers';

export default ({nextNews, prevNews}: ViewProps) => {
  const navigation = useNavigation();
  const theme = useTheme();

  const styles = useStyles(({addShadow, mediaOnly}) => ({
    container: {
      marginTop: 40,
      marginBottom: 60,
    },
    card: {
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.25,
      }),
      padding: 20,
      backgroundColor: theme.color.backgroundMenuColor,
      marginHorizontal: 20,
      borderRadius: 5,
    },
    cardNext: {
      marginTop: 20,
      alignItems: 'flex-end',
    },
    cardButton: {
      flexDirection: 'row',
      width: '100%',
      height: 24,
      marginBottom: 10,
    },
    cardButtonPrev: {
      justifyContent: 'flex-start',
    },
    cardButtonNext: {
      justifyContent: 'flex-end',
    },
    cardButtonText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h6, theme.fonts.h6Light),
      color: theme.color.primaryColor,
    },
    textLeft: {
      marginLeft: 2,
    },
    textRight: {
      marginRight: 2,
    },
  }));

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <TouchableOpacity
          testID={`footer-news-article-to-prev-${prevNews.id}-id`}
          onPress={() => navigation.navigate(Screens.NewsArticle, {id: prevNews.id})}>
          <View style={[styles.cardButton, styles.cardButtonPrev]}>
            <images.Left width={18} color={theme.color.primaryColor} />
            <Text style={[styles.cardButtonText, styles.textLeft]}>Предыдущая</Text>
          </View>
        </TouchableOpacity>
        <Text>{prevNews.name}</Text>
      </View>
      <View style={[styles.card, styles.cardNext]}>
        <TouchableOpacity
          testID={`footer-news-article-to-next-${nextNews.id}-id`}
          onPress={() => navigation.navigate(Screens.NewsArticle, {id: nextNews.id})}>
          <View style={[styles.cardButton, styles.cardButtonNext]}>
            <Text style={[styles.cardButtonText, styles.textRight]}>Следующая</Text>
            <images.Right width={18} color={theme.color.primaryColor} />
          </View>
        </TouchableOpacity>
        <Text>{nextNews.name}</Text>
      </View>
    </View>
  );
};
